/* eslint-disable react/prop-types */
import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import { useTranslation } from "react-i18next"
import { useToasts } from "react-toast-notifications"
import get from "lodash.get"
import { Formik } from "formik"
import * as Yup from "yup"
import capitalize from "lodash.capitalize"
import { withFirebase } from "../../../utils/Firebase"
import { generatePassword, getReferenceCode } from "../../../utils/App"
import CustomInput from "../../atoms/CustomInput"
import CustomSelect from "../../atoms/CustomSelect"
import Drawer from "../../atoms/Drawer"
import { StyledForm, SubmitButton } from "./styles"

const organizationRoles = [
  { value: "business_partner", label: "Administrador" },
  { value: "client", label: "Empleado" },
]

const recordTypes = [
  { value: "new", label: "Colaborador nuevo" },
  { value: "exisisting", label: "Colaborador existente" },
]

const VisitorDrawer = ({
  firebase,
  open,
  closeDrawer,
  orgId,
  orgName,
  country,
}) => {
  const { t } = useTranslation()
  const { addToast } = useToasts()
  const [isCreating, setIsCreating] = useState(false)
  const [role, setRole] = useState(organizationRoles[0])
  const [location, setLocation] = useState({})
  const [locationList, setLocationList] = useState([])
  const createAdminUrl = `${process.env.REACT_APP_FUNCTIONS_URL}/authUserCreateNew`
  const mailerUrl = `${process.env.REACT_APP_FUNCTIONS_URL}/mailerSend`
  const [orgLocationList, setOrgLocationList] = useState([])

  const [departments, setDepartments] = useState([])
  const [departmentList, setDepartmentList] = useState([])
  const [department, setDepartment] = useState({})
  const [recordType, setRecordType] = useState(undefined)
  const [isNewColaborator, setIsNewColaborator] = useState(true)
  const [users, setUsers] = useState([])
  const [usersList, setUsersList] = useState([])
  const [selectedUser, setSelectedUser] = useState({})

  const getDeparmentsByLocation = async (locationId) => {
    const depts = await firebase.getOrgDepartmentByLocation(orgId, locationId)
    setDepartments(depts)
  }

  useEffect(() => {
    const getUsers = async () => {
      const usersL = await firebase.getUsersByType("client")
      const result = []

      const sortedUsers =
        usersL.docs && usersL.docs.length > 0
          ? usersL.docs
              .map((d) => {
                const userData = d.data()
                return {
                  id: d.id,
                  ...userData,
                  displayName: userData.displayName
                    ? userData.displayName
                    : `${capitalize(userData.name)} ${capitalize(
                        userData.surname1
                      )}`,
                }
              })
              .sort((a, b) => a.displayName - b.displayName)
          : []
      setUsers(sortedUsers)
      if (sortedUsers && sortedUsers.length > 0) {
        sortedUsers.forEach((u) => {
          result.push({
            value: u.id,
            label: u.id,
          })
        })
      }

      setUsersList(result)
    }
    if (users.length === 0 && firebase) {
      getUsers()
    }
  }, [isNewColaborator, firebase])

  useEffect(() => {
    const fetchData = () => {
      const result = []
      if (departments && departments.length > 0) {
        departments.forEach((dept) => {
          result.push({
            value: dept.id,
            label: dept.displayName,
          })
        })
      }
      // setDepartment(result.filter((r) => r.value === currentDepartment))

      setDepartmentList(result)
    }
    fetchData()
  }, [departments])

  useEffect(() => {
    if (orgId) {
      const getForm = async () => {
        const orgLocations = await firebase.getOrgLocationList(orgId)
        setOrgLocationList(orgLocations)
      }
      getForm()
    }
  }, [orgId])

  useEffect(() => {
    if (orgLocationList && orgLocationList.length > 0) {
      const result = []
      orgLocationList.forEach((loc) => {
        result.push({
          value: loc.id,
          label: loc.displayName,
        })
      })

      setLocationList(result)
    }
  }, [orgLocationList])

  useEffect(() => {
    if (location && location.length > 0) {
      const fetchData = async () => {
        await getDeparmentsByLocation(location[0].value)
      }
      fetchData()
    }
  }, [location])

  const getInviteHeader = (type) => {
    let emailType = ""
    switch (type) {
      case "business_partner":
        emailType = "Administrador"
        break
      case "client":
        emailType = "Empleado"
        break
      default:
        emailType = "Visitador Médico"
    }

    return emailType
  }

  const getEmailTemplate = (type) => {
    let templateId = 0
    switch (type) {
      case "business_partner":
        templateId = 2358080
        break
      case "client":
        templateId = 6020425
        break
      default:
        templateId = 2358085
    }

    return templateId
  }

  return (
    <Drawer
      openDrawer={open}
      closeDrawer={closeDrawer}
      title={t("create_visitor")}
      internal
    >
      <div>
        <Formik
          initialValues={{
            type: "business_partner",
            email: undefined,
            confirmEmail: undefined,
            password: generatePassword(),
            displayName: undefined,
            phoneNumber: undefined,
            location: undefined,
            department: undefined,
          }}
          onSubmit={async (values, { resetForm }) => {
            setIsCreating(true)
            try {
              const token = await firebase.getIdToken()
              fetch(createAdminUrl, {
                method: "POST",
                body: JSON.stringify({ user: values }),
                headers: {
                  Authorization: `Bearer ${token}`,
                  "Content-Type": "application/json",
                },
              }).then(async (dataResponse) => {
                const parsedRes = await dataResponse.json()
                const { error } = parsedRes

                if (
                  dataResponse.status === 200 ||
                  (error &&
                    error.message.includes(
                      "The email address is already in use"
                    ) &&
                    values.type === "client")
                ) {
                  try {
                    let templateId = getEmailTemplate(values.type)
                    let isExistingAgent = false
                    let existingAgent = []

                    if (
                      error &&
                      error.message.includes(
                        "The email address is already in use"
                      )
                    ) {
                      templateId = 6333133
                      isExistingAgent = true
                      existingAgent = await firebase.checkExistingAgent(
                        values.email
                      )
                    }

                    // Check array for all orgs
                    if (
                      existingAgent.length > 0 &&
                      existingAgent.some((a) => a.active)
                    ) {
                      addToast(
                        `La dirección de correo ya está siendo utilizada por otra cuenta en la empresa ${existingAgent[0].businessName}`,
                        {
                          appearance: "error",
                          placement: "bottom-center",
                        }
                      )
                      setIsCreating(false)
                    } else {
                      // This timeout gives time for the firebase trigger to be executed
                      setTimeout(async () => {
                        await fetch(mailerUrl, {
                          method: "POST",
                          body: JSON.stringify({
                            data: {
                              templateId,
                              email: values.email,
                              variables: {
                                subject: `Te han invitado como ${getInviteHeader(
                                  values.type
                                )} a la organización ${orgName}`,
                                orgName,
                                displayName: values.displayName,
                                password: values.password,
                              },
                            },
                          }),
                          headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "application/json",
                          },
                        })
                        const getCodeToReference = getReferenceCode()

                        if (
                          isExistingAgent &&
                          existingAgent.some((a) => a.orgId === orgId)
                        ) {
                          await firebase.saveAgentData({
                            orgId,
                            id: existingAgent[0].id,
                            data: {
                              active: true,
                              createdAt: Date.now(),
                            },
                          })
                        } else {
                          await firebase.addOrgColaborator({
                            orgId,
                            email: values.email,
                            agentData: {
                              email: values.email,
                              displayName: values.displayName,
                              phoneNumber: values.phoneNumber,
                              phone: values.phoneNumber,
                              active: true,
                              createdAt: Date.now(),
                              referenceCode: getCodeToReference,
                              role: values.type,
                              ...(values.location && {
                                location: values.location,
                              }),
                              ...(values.department && {
                                department: values.department,
                              }),
                              ...(values.type === "business_partner" && {
                                officeId: orgId,
                              }),
                            },
                          })
                        }
                        let userUpdatePayload = {}
                        if (isExistingAgent) {
                          userUpdatePayload = {
                            active: true,
                            status: "active",
                            organizationId: orgId,
                          }
                        } else {
                          userUpdatePayload = {
                            displayName: values.displayName,
                            email: values.email,
                            active: true,
                            status: "active",
                            country,
                            userType:
                              values.type === "business_partner"
                                ? "admin"
                                : "client",
                            phoneNumber: values.phoneNumber,
                            organizationId: orgId,
                            referenceCode: getCodeToReference,
                            roles: {
                              BUSINESS_ADMIN:
                                values.type === "business_partner",
                            },
                          }
                        }

                        await firebase.saveUserData({
                          email: values.email,
                          data: userUpdatePayload,
                        })

                        addToast(t("saved_successfully"), {
                          appearance: "success",
                          placement: "bottom-center",
                        })
                        resetForm({ value: "" })
                        setRole(organizationRoles[0])
                        setLocation(locationList[0])
                        setIsCreating(false)
                        closeDrawer()
                      }, 2500)
                    }
                  } catch (e) {
                    console.log("Unexpected error:", e)
                    addToast(t("unexpected_error"), {
                      appearance: "error",
                      placement: "bottom-center",
                    })
                    setIsCreating(false)
                  }
                } else {
                  addToast(t("unexpected_error"), {
                    appearance: "error",
                    placement: "bottom-center",
                  })

                  setIsCreating(false)
                }
              })
            } catch (e) {
              setIsCreating(false)
            }
          }}
          validationSchema={Yup.object({
            type: Yup.string().required(t("error_all_fields_required")),
            email: Yup.string()
              .email(t("error_auth_invalid_email"))
              .required(t("error_all_fields_required")),
            confirmEmail: Yup.string()
              .oneOf([Yup.ref("email"), null], t("error_email_must_match"))
              .required(t("error_all_fields_required")),
            displayName: Yup.string().required(t("error_all_fields_required")),
            phoneNumber: Yup.number()
              .typeError(t("error_phone_number"))
              .required(t("error_all_fields_required")),
          })}
        >
          {(props) => (
            <StyledForm onSubmit={props.handleSubmit}>
              <p>
                Ingrese los datos de contacto del nuevo colaborador que desea
                crear dentro de la organización.
              </p>
              <CustomSelect
                value={recordType}
                formKey="recordType"
                lngKey="create_visitor"
                handleChange={(event, value) => {
                  if (value === "new") setIsNewColaborator(true)
                  else setIsNewColaborator(false)
                  setRecordType(recordTypes.filter((r) => r.value === value))

                  props.setFieldValue("email", "")
                  props.setFieldValue("confirmEmail", "")
                  props.setFieldValue("displayName", "")
                  // props.setFieldValue("surname1", "")
                  // props.setFieldValue("surname2", "")
                  props.setFieldValue("phoneNumber", "")
                  setSelectedUser(undefined)
                }}
                items={recordTypes}
                showError={
                  !props.values.recordType && Boolean(props.errors.recordType)
                }
              />
              <CustomSelect
                value={role}
                formKey="type"
                lngKey="usr_type"
                handleChange={(event, value) => {
                  props.setFieldValue("type", value)
                  setRole(organizationRoles.filter((r) => r.value === value))
                }}
                items={organizationRoles}
                showError={!props.values.type && Boolean(props.errors.type)}
              />
              {isNewColaborator && (
                <>
                  <CustomInput
                    touched={props.touched.displayName}
                    errors={props.errors.displayName}
                    icon="user"
                    value={props.values.displayName}
                    onChange={props.handleChange}
                    onBlur={props.handleBlur}
                    labelName={t("display_name_label")}
                    type="text"
                    id="displayName"
                    name="displayName"
                  />
                  <CustomInput
                    touched={props.touched.email}
                    errors={props.errors.email}
                    icon="email"
                    value={props.values.email}
                    onChange={props.handleChange}
                    onBlur={props.handleBlur}
                    labelName={t("email_address")}
                    type="email"
                    id="email"
                    name="email"
                  />
                  <CustomInput
                    touched={props.touched.confirmEmail}
                    errors={props.errors.confirmEmail}
                    icon="email"
                    value={props.values.confirmEmail}
                    onChange={props.handleChange}
                    onBlur={props.handleBlur}
                    labelName={t("email_address_verify")}
                    type="email"
                    id="confirmEmail"
                    name="confirmEmail"
                    avoidCopyAndPaste
                  />
                  <CustomInput
                    touched={props.touched.phoneNumber}
                    errors={props.errors.phoneNumber}
                    icon="phone"
                    value={props.values.phoneNumber}
                    onChange={props.handleChange}
                    onBlur={props.handleBlur}
                    labelName={t("phone_label")}
                    type="text"
                    id="phoneNumber"
                    name="phoneNumber"
                  />
                </>
              )}

              {!isNewColaborator && (
                <>
                  <CustomSelect
                    value={selectedUser}
                    formKey="orgs_users"
                    lngKey="orgs_users"
                    label="orgs_users"
                    handleChange={(event, value) => {
                      setSelectedUser(
                        usersList.filter((r) => r.value === value)
                      )

                      const u = users.filter((r) => r.id === value)

                      if (u) {
                        props.setFieldValue("email", u[0].id)
                        props.setFieldValue("confirmEmail", u[0].id)
                        props.setFieldValue("displayName", u[0].displayName)
                        // // props.setFieldValue("surname1", "")
                        // // props.setFieldValue("surname2", "")
                        props.setFieldValue(
                          "phoneNumber",
                          get(u[0], "phoneNumber.formattedNumber") ??
                            get(u[0], "phoneNumber")
                        )
                      }
                    }}
                    items={usersList}
                    showError={!props.values.type && Boolean(props.errors.type)}
                  />
                </>
              )}

              <CustomSelect
                value={location}
                formKey="location"
                lngKey="location_name_label"
                label="location_name_label"
                handleChange={async (event, value) => {
                  props.setFieldValue("location", value)
                  setLocation(locationList.filter((r) => r.value === value))
                  setDepartment(null)
                  await getDeparmentsByLocation(value)
                }}
                items={locationList}
                showError={
                  !props.values.location && Boolean(props.errors.location)
                }
              />
              <CustomSelect
                value={department}
                formKey="department"
                lngKey="department_name_label"
                label="department_name_label"
                handleChange={(event, value) => {
                  props.setFieldValue("department", value)
                  setDepartment(departmentList.filter((r) => r.value === value))
                }}
                items={departmentList}
              />
              <SubmitButton
                iconName="login"
                isLoading={isCreating}
                type="submit"
              >
                {t("create")}
              </SubmitButton>
            </StyledForm>
          )}
        </Formik>
      </div>
    </Drawer>
  )
}

VisitorDrawer.defaultProps = {
  open: false,
}

VisitorDrawer.propTypes = {
  firebase: PropTypes.shape().isRequired,
  open: PropTypes.bool,
  closeDrawer: PropTypes.func.isRequired,
  orgId: PropTypes.string.isRequired,
  orgName: PropTypes.string.isRequired,
  country: PropTypes.string.isRequired,
}
export default withFirebase(VisitorDrawer)
